import { render } from "./RegistartionSection.vue?vue&type=template&id=7805ad84&scoped=true"
const script = {}

import "./RegistartionSection.vue?vue&type=style&index=0&id=7805ad84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7805ad84"]])

export default __exports__